import { render, staticRenderFns } from "./AppointmentTypesSettings.vue?vue&type=template&id=73d0d10d&scoped=true&"
import script from "./AppointmentTypesSettings.vue?vue&type=script&lang=ts&"
export * from "./AppointmentTypesSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentTypesSettings.vue?vue&type=style&index=0&id=73d0d10d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d0d10d",
  null
  
)

export default component.exports